import React, { useState, useEffect } from 'react';
import blogformcss from './blogform.module.css';
import { Link } from 'react-router-dom';
import Carousel from 'react-bootstrap/Carousel';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { Button } from 'react-bootstrap';
import BlogModal from './BlogModal';
import API_URL from "../../config/api";

function BlogForm() {

    const [index, setIndex] = useState(0);
    const [error, setError] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [blogPostData, setBlogPostData] = useState([]);
    const [showModal, setShowModal] = useState(false);

    useEffect(() => {
        fetchBlogPosts();
    }, []);

    const fetchBlogPosts = async () => {
        setIsLoading(true);

        try {

            const response = await fetch(`${API_URL}/blog/get_blog_posts.php`
            );

            const result = await response.json();

            if (result.success) {
                setBlogPostData(result.data);
            }

        } catch (err) {

            console.error(err);
            setError(err.message);
            toast.error(err.message);

        } finally {

            setIsLoading(false);

        }
    };

    const truncate = (text, maxLength) => {

        if (!text) return "";

        return text.length > maxLength
            ? text.substring(0, maxLength - 3) + "..."
            : text;
    };

    const handleSelect = (selectedIndex) => {
        setIndex(selectedIndex);
    };

    const chunkArray = (array, size) => {

        const chunks = [];

        for (let i = 0; i < array.length; i += size) {
            chunks.push(array.slice(i, i + size));
        }

        return chunks;
    };

    const blogPostChunks = chunkArray(blogPostData, 3);

    const handleShowModal = () => setShowModal(true);

    const handleCloseModal = () => {
        setShowModal(false);
        fetchBlogPosts(); // refresh after posting
    };

        return (
        <>
            <div
                className={blogformcss.carousel}
                style={{ position: "relative" }}
            >
                <h2 className="center">Blog Posts:</h2>

                <div
                    className="d-flex justify-content-end align-items-end"
                    style={{ marginRight: "15%" }}
                >
                    <Button
                        variant="primary"
                        onClick={handleShowModal}
                    >
                        Post a Blog
                    </Button>
                </div>

                <Carousel
                    activeIndex={index}
                    onSelect={handleSelect}
                >
                    {blogPostChunks.map((chunk, chunkIndex) => (

                        <Carousel.Item key={chunkIndex}>

                            <div className={blogformcss.carouselInner}>

                                {chunk.map((post) => (

                                    <div
                                        className={blogformcss.card}
                                        key={post.id}
                                    >

                                        <img
                                            className={blogformcss.carouselImg}
                                            src={post.imgurl}
                                            alt={post.title}
                                        />

                                        <div className={blogformcss.cardBody}>

                                            <h3>{post.title}</h3>

                                            <p>
                                                Posted by: {post.name}
                                            </p>

                                            <p className="truncate-text">
                                                {truncate(post.content, 30)}
                                            </p>

                                            <Link
                                                to={`/BlogPost?postId=${post.id}`}
                                                className="button_view"
                                                role="button"
                                            >
                                                Read More
                                            </Link>

                                        </div>

                                    </div>

                                ))}

                            </div>

                        </Carousel.Item>

                    ))}
                </Carousel>
            </div>

            <br />
            <br />
            <br />

            <BlogModal
                show={showModal}
                handleClose={handleCloseModal}
            />

            {error && <p className="error">{error}</p>}

            <ToastContainer
                position="top-center"
                autoClose={2000}
            />
        </>
    );
}

export default BlogForm;